import { api } from '../configs/axiosConfigs';
import {
  MiniBetListWrapperDTO,
  OutrightsDTO,
  ParlayBetRequest,
  ParlayBetResponse,
  ResultDTO,
  ResultFilter,
  SingleBetRequest,
  SingleBetResponse,
  StatementDetailFilter,
  StatementDTO,
  StatementFilter,
  StatementRecordDTO,
} from '../../interface/bets';
import { UserInfo } from '../../interface/users';
import { Utils } from '../../../../styleguide/src/utils';
import axios from 'axios';
import { TeamLeagueType } from '../../supersports-services';

export const BetsAPI = {
  getMiniBets: async ({ SsToken }: UserInfo) => {
    const response = await api.get('/api/v1/bet/mini-bet-list', {
      headers: {
        Authorization: `Bearer ${SsToken}`,
      },
    });

    return (response.data as any).Data as MiniBetListWrapperDTO;
  },
  previewBet: async (bet: SingleBetRequest) => {
    const response = await api.post('preview-bet', bet, {});

    return response.data;
  },
  placeSingleBet: async (bet: SingleBetRequest, { SsToken }: UserInfo) => {
    try {
      const response = await api.post('/api/v1/bet/single-bet', bet, {
        headers: {
          Authorization: `Bearer ${SsToken}`,
        },
      });

      return response.data.Data as SingleBetResponse;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw error;
      }
    }
  },
  placeParlayBet: async (_bet: ParlayBetRequest, { SsToken }: UserInfo) => {
    const bet = { ..._bet };
    // remove all id inside bet.BetArgs
    bet.BetArgs = bet.BetArgs.map((arg) => {
      const { id, BetPositionLabel, ...rest } = arg;
      return rest;
    });

    try {
      const response = await api.post('/api/v1/bet/parlay-bet', bet, {
        headers: {
          Authorization: `Bearer ${SsToken}`,
        },
      });

      return response.data.Data as ParlayBetResponse;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw error;
      }
    }
  },

  getOutrights: async (filter: ResultFilter, { SsToken }: UserInfo) => {
    const { Refresh, MatchDate, Type, ...transformedFilter } = filter;

    const response = await api.request({
      url: '/api/v1/match-result/outright-result',
      method: 'GET',
      params: { ...transformedFilter, LeagueID: filter.LeagueID !== '0' ? filter.LeagueID : '', size: 1000 },
      headers: {
        Authorization: `Bearer ${SsToken}`,
      },
    });

    return (response.data as any).Data as OutrightsDTO[];
  },

  getResult: async (filter: ResultFilter, { SsToken }: UserInfo) => {
    const { Refresh, StartDate, EndDate, Type, ...transformedFilter } = filter;

    const response = await api.request({
      url: '/api/v1/match-result/match-result',
      method: 'GET',
      params: { ...transformedFilter, LeagueID: filter.LeagueID !== '0' ? filter.LeagueID : '', size: 1000 },
      headers: {
        Authorization: `Bearer ${SsToken}`,
      },
    });

    return (response.data as any).Data as ResultDTO[];
  },

  getStatement: async (filter: StatementFilter, { SsToken }: UserInfo) => {
    const { Week, Refresh, ...filterApi } = filter;

    const response = await api.request({
      url: '/api/v1/statement/statement-summary',
      method: 'GET',
      params: {
        ...filterApi,
        ...{
          IsThisWeek: filter.Week === 'thisWeek',
        },
      },
      headers: {
        Authorization: `Bearer ${SsToken}`,
      },
    });

    return (response.data as any).Data as StatementDTO[];
  },

  getStatementDetail: async (filter: StatementDetailFilter, { SsToken }: UserInfo) => {
    const { CurrentDate, Refresh, ...filterApi } = filter;

    const response = await api.request({
      url: '/api/v1/statement/statement-detail',
      method: 'GET',
      params: {
        ...filterApi,
        ...{
          Date: Utils.formatDate(CurrentDate, 'yyyy-MM-dd'),
        },
      },
      headers: {
        Authorization: `Bearer ${SsToken}`,
      },
    });

    return (response.data as any).Data as StatementRecordDTO[];
  },

  getLanguageSearch: async (type: TeamLeagueType, mappingId: number) => {
    const response = await api.request({
      url: '/api/v1/language/search',
      method: 'GET',
      params: { LanguageType: type, LanguageID: mappingId },
    });

    return response.data as any;
  },
};
